import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { BaseStudentListComponent } from '../../../../shared/base-student-list/base-student-list.component';
import { IStudentsListFilters } from '../../../students/students-list-models/students-list-filters.interface';
import {
  DateUtil,
  StudentPerformanceDto
} from '@whetstoneeducation/hero-common';
import { AppEventService } from '../../events.service';
import { AppStudentsService } from '../../../students/students.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppToastManagerService } from '../../../../shared/services/toast-manager.service';
import { AddStudentColumnsEnum } from '../../../custom-rosters/custom-roster-models/add-student-columns.enum';

@Component({
  selector: 'app-hero-event-create-edit-add-student',
  templateUrl: './hero-event-create-edit-add-student.component.html',
  styleUrls: ['./hero-event-create-edit-add-student.component.scss']
})
export class AppHeroEventCreateEditAddStudentComponent
  extends BaseStudentListComponent
  implements OnInit, OnDestroy
{
  public isLoading: boolean = true;
  public heroEventId: number;
  public search: string;
  public grade: string;
  public filters: IStudentsListFilters;
  studentsAdded: number[] = [];
  students: StudentPerformanceDto[] = [];
  constructor(
    public eventsService: AppEventService,
    public studentsService: AppStudentsService,
    public dialogRef: MatDialogRef<AppHeroEventCreateEditAddStudentComponent>,
    public toastService: AppToastManagerService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      heroEventId: number;
      onClose: () => Promise<void>;
    }
  ) {
    super(studentsService, toastService);
  }
  async ngOnDestroy() {
    await this.data.onClose();
  }

  async ngOnInit() {
    this.heroEventId = this.data.heroEventId;
    const currentSchoolId = this.StorageManager.getCurrentSchoolId();
    if (!currentSchoolId) {
      this.toastService.error('Please select a school first');
      this.dialogRef.close();
      this.isLoading = false;

      return;
    }
    await this.loadFiltersAndStudents({ heroEventId: this.heroEventId });
    this.isLoading = false;
  }
  async handleClose() {
    await this.data.onClose();
    this.dialogRef.close();
  }

  public get displayedColumns() {
    return Object.values(AddStudentColumnsEnum);
  }

  public columnValues = {
    [AddStudentColumnsEnum.STUDENT_NAME]: ['Student Name'],
    [AddStudentColumnsEnum.STUDENT_ID]: ['Student ID'],
    [AddStudentColumnsEnum.GRADE]: ['Grade'],
    [AddStudentColumnsEnum.ACTION]: ['Add']
  };

  async addStudent(studentId: number) {
    this.isLoading = true;
    try {
      await this.eventsService.addStudentToHeroEvent(
        this.heroEventId,
        studentId
      );
      this.studentsAdded.push(studentId);
      await this.updateStudentsList(this.filters);
    } catch (error) {
      this.toastService.error('Failed to add student');
    }
    this.isLoading = false;
  }

  protected readonly columns = AddStudentColumnsEnum;
  protected readonly DateUtil = DateUtil;
}
